import { Group, Loader } from "@mantine/core";

function LoadingSpinner() {
	return (
		<Group
			justify="center"
			py="xl">
			<Loader size="lg" />
		</Group>
	);
}

export default LoadingSpinner;
